import { GridColDef, GridRowsProp } from '@mui/x-data-grid';
import { useContext, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { AppContext } from '../../../../app-context';
import IGridComponent from '../../../../components/grid/i-grid.component';
import TitlePanel from '../../../../components/title-panel/title-panel.component';
import { formatDate, isEmptyArray } from '../../../common/util.services';
import './ord-sch-list.component.scss';
import { getScheduleByOrderCode } from '../../production.services';
import ProductDetailComponent from '../../../enquiry/enq-product/product-detail.component';
import { getEnquiryProduct } from '../../../enquiry/enquiry.services';
import IDialogComponent from '../../../../components/dialog/i-dialog.component';
import { Stack } from '@mui/system';
import { IconButton } from '@mui/material';
import { HelpOutline } from '@mui/icons-material';

const OrderScheduleList = () => {
  const appContext = useContext(AppContext);
  const navigate = useNavigate();
  const rows: GridRowsProp = [];
  const params = useParams();
  const [openPrdDetail, setOpenPrdDetail] = useState(false);
  const [prdDetail, setPrdDetail] = useState(null);
  const [scheduleData, setScheduleData] = useState(rows);
  const columns: GridColDef[] = [
    { field: 'code', headerName: 'Sch Code', filterable: false, sortable: false, editable: false, width: 120,
      renderCell: (params) => { return <div className="cell-link" 
      onClick={() => { openEditPage(params.row) }}>{params.row.code}</div>}
    },
    { field: 'costingCode', headerName: 'Cos Code', filterable: false, sortable: false, editable: false, width: 120 },
    { field: 'product', headerName: 'Product', filterable: false, sortable: false, editable: false, width: 160 },
    { field: 'description', headerName: 'Desc', filterable: false, sortable: false, editable: false, width: 185,
      renderCell: (params) => (<Stack direction="row" alignItems="center" gap={0}>
                                <IconButton size="small" onClick={() => openPrdDetailPage(params.row.enqPrdId)}
                                  sx={{ p: 0.6, ml: -1 }}> <HelpOutline fontSize="small" color='secondary'/>
                                </IconButton>{params.row.description}</Stack>)
    },
    { field: 'quantity', headerName: 'Quantity', filterable: false, sortable: false, editable: false, width: 95,
      renderCell: (params) => {return params.row.quantity + ' ' + params.row.uom}
    },
    { field: 'pack', headerName: 'Pc/Pack', filterable: false, sortable: false, editable: false, width: 70,
      valueFormatter: (value: any) => 0 === value ? 'NA' : value
    },
    { field: 'status', headerName: 'Status', filterable: false, sortable: false, editable: false, width: 75 },
    { field: 'orderDate', headerName: 'Order Date', filterable: false, sortable: false, editable: false, width: 90,
      valueFormatter: (scheduleDate: any) => formatDate(scheduleDate)
    },
    { field: 'targetDate', headerName: 'Target Date', filterable: false, sortable: false, editable: false, width: 95,
      valueFormatter: (targetDate: any) => formatDate(targetDate)
    },
    { field: 'dispatchDate', headerName: 'LFH Target', filterable: false, sortable: false, editable: false, width: 100,
      valueFormatter: (dispatchDate: any) => formatDate(dispatchDate)
    },
    { field: 'daysLeft', headerName: 'Days Left', filterable: false, sortable: false, editable: false, width: 80 },
    { field: 'ageing', headerName: 'Ageing', filterable: false, sortable: false, editable: false, width: 60 },
    { field: 'remarks', headerName: 'Remarks', filterable: false, sortable: false, editable: false, width: 100 },
  ];
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (isEmptyArray(rows)) {
      getScheduleByOrderCode(params.orderCode, 0, 100, appContext,
        (response: any) => {
          setScheduleData(response.data.data);
          appContext.setShowLoader(false);
          setLoading(false);
        }, (error: any) => {
          appContext.setShowLoader(false);
          appContext.setErrorMessage(error.message);
          setLoading(false);
        });
    }
  }, []);

  const openEditPage = (row: any) => {
    navigate('/production/schedule/' + row.rowId, {state: {orderId: row.rowId, orderCode: row.code}});
  }

  const closePrdDetail = () => {
    setOpenPrdDetail(false);
  }

  const openPrdDetailPage = (prdId: string) => {
    getEnquiryProduct(prdId, appContext,
      (response: any) => {
        appContext.setShowLoader(false);
        setPrdDetail(response.data);
        setOpenPrdDetail(true);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message);
      });
  }

  const getMainPanel = () => {
    return <>
      <IGridComponent title={''} rows={scheduleData} columns={columns} loading={loading} showAction={false}
        showAddBtn={false} showApproveAction={false} showDeleteAction={false} showUpAction={false} showDownAction={false}
        getRowId={(row: any) => row.rowId} showEditAction={false} handleEditAction={openEditPage} hideFooterPagination={true}/>
      <IDialogComponent onClose={closePrdDetail} open={openPrdDetail} title={'Product Details'}
        dialogBody={<ProductDetailComponent readOnly={true} data={prdDetail} close={closePrdDetail}/>} />
    </>
  }

  return <TitlePanel title='Schedules For Order' panelBody={getMainPanel()} />
}

export default OrderScheduleList;